import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, RouterStateSnapshot } from '@angular/router';

/**
 * Route guard to control the accessibility of the /profile/:id/overview route
 */
@Injectable({
  providedIn: 'root',
})
export class ProfileSettingsLoginGuardGuard  {
  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return true;
  }

  public canLoad(_: Route): boolean {
    return true;
  }
}
